<script>
import AsyncRenderComp from './asyncRenderComp.vue'
import CommUploadFiles from '../CommUploadFiles/index.vue'
import ct from "../CommEditForm/compType.js"

const supperType = [
  ct.TEXT,
  ct.TEXTINPUT,
  ct.TEXTAREA,
  ct.NUMBERINPUT,
  ct.SINGLESELECT,
  ct.MULTIPLESELECT,
  ct.UPLOADFILES,
  ct.RADIOGROUP,
  ct.DATEPICKER]

export default {
  name: 'CommDialog',
  components: { AsyncRenderComp, CommUploadFiles },
  data() {
    return {
      compList: [],
      attrs: [],
      visible: false,
      mode: 0,
      dialog: {
        title: 'CommDialog',
        width: '720px'
      },
      btn: {
        okBtn: {
          text: '确定',
          show: true,
          icon: 'el-icon-check',
          type: 'primary'
        },
        cancleBtn: {
          text: '取消',
          show: true,
          icon: 'el-icon-close',
          type: 'default'
        }
      },
    }
  },
  destroyed() {
    document.body.removeChild(this.$el);
  },
  updated() {
    if (!this.visible) {
      this.$destroy();
    }
  },
  render(h) {
    if (!this.visible) {
      return null;
    }
    return this.renderMain()
  },
  methods: {
    renderTitleIcon() {
      if (this.mode === 1) { // --Confirm
        return <i
          style="font-size: 18px; margin-left: 10px"
          class="bi bi-exclamation-triangle-fill"
        />
      }
      if (this.mode === 2) { // --Input
        return <i
          style="font-size: 18px; margin-left: 10px"
          class="bi bi-pencil-square"
        />
      }
      return <i
        style="font-size: 18px; margin-left: 10px"
        class="bi bi-pencil-square"
      />
    },
    /** 渲染头部 */
    renderDialogTitle() {
      const { dialog, btn } = this
      return (
        <el-row type="flex" justify="space-between" align="middle">
          <el-row type="flex" justify="start" align="middle">
            {this.renderTitleIcon()}
            <b class="edit-title">{dialog.title}</b>
            {dialog.tag && <i class="text-tag" style="font-size: 12px">  [{dialog.tag}]</i>}
          </el-row>
        </el-row>)
    },
    /** 渲染脚部 */
    renderDialogFooter() {
      const { btn } = this
      return (<el-row type="flex" justify="end" align="middle">
        {btn.cancleBtn.show && <el-button
          size="mini"
          icon={btn.cancleBtn.icon}
          type={btn.cancleBtn.type}
          on-click={e => this.onCancle(e)}
        >{btn.cancleBtn.text}</el-button>}
        {btn.okBtn.show && <el-button
          size="mini"
          icon={btn.okBtn.icon}
          type={btn.okBtn.type}
          on-click={e => this.onOK(e)}
        >{btn.okBtn.text}</el-button>}
      </el-row>)
    },
    /** 主渲染 */
    renderMain() {
      const { mode, visible, dialog } = this
      const dialogClass = `order-files-dialog ${mode === 1 ? 'spec' : ''}`
      return (
        <div id="order-files-box">
          <el-dialog
            class={dialogClass}
            title={dialog.title}
            ref="orderFilesDialog"
            visible={visible}
            show-close={true}
            close-on-click-modal={false}
            close-on-press-escape={false}
            width={dialog.width}
            before-close={this.onCancle}
            destroy-on-close
            v-el-drag-dialog
          >
            {this.renderBody()}
            <template slot="footer">
              {this.renderDialogFooter()}
            </template>
          </el-dialog>
        </div>
      )
    },
    /** 渲染主体 */
    renderBody() {
      const { mode, dialog, compList } = this
      // --Open
      if (mode === 0) {
        return compList.map(c => {
		
          return (
            <async-render-comp
              ref={c.compRef}
              key={c.key}
              compProps={c.compProps}
              compPath={c.compPath}
              compEvents={c.compEvents}
            ></async-render-comp>)
        })
      }
      // --Confirm
      if (mode === 1) {
        return (
          <div>
            <el-row type="flex" justify="start" align="middle">
              <div class="confirm-icon">
                <svg
                  t="1651246371704"
                  class="icon"
                  viewBox="0 0 1176 1024"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  p-id="13934"
                  width="48"
                  height="48"
                >
                  <path
                    d="M1050.586326 1004.899991c94.288103 0 133.986347-62.200279 88.204538-138.242457L662.669584 75.817922c-45.786581-76.023093-119.819991-75.579351-164.52823 0.97337L37.355429 865.698478c-44.717782 76.562264-4.15591 139.201513 90.141736 139.201513h923.089161z"
                    fill="#FFE875"
                    p-id="13935"
                  ></path>
                  <path
                    d="M1157.88133 863.82808L681.755278 72.988468c-45.786581-76.023093-119.819991-75.579351-164.52823 0.97337l-3.941196 6.765879c34.635764-26.405058 76.605207-14.667356 105.176492 35.532792l391.266281 687.280633c37.622675 66.084217 4.995681 120.15399-72.482696 120.15399H178.713626c-77.473606 0-110.811543-54.451487-74.057266-120.960361L331.112898 392.640452l-274.65746 470.2238c-44.727325 76.562264-4.160681 139.211056 90.136964 139.211056h923.08439c94.283331 0 133.981576-62.20505 88.204538-138.247228z"
                    fill="#FFD175"
                    p-id="13936"
                  ></path>
                  <path
                    d="M1050.586326 1023.985686H127.492393c-53.950487 0-96.106015-19.534208-115.654537-53.587859-18.455867-32.149853-15.244699-72.749896 9.037076-114.323311l460.785924-788.907185C506.954173 23.852347 542.028908 0 580.419783 0c37.966218 0 72.978925 23.42769 98.606241 65.969703l476.12128 790.839612c24.897289 41.353929 28.633313 81.77743 10.516218 113.822312-19.162037 33.905736-61.102851 53.354059-115.077196 53.354059zM580.419783 38.171389c-24.257918 0-47.623579 17.134182-65.797932 48.243865l-460.785924 788.907185c-17.096011 29.263141-20.249922 56.278942-8.889163 76.066036 12.558387 21.872206 42.646985 34.42105 82.550401 34.42105h923.093933c39.81753 0 69.648471-12.377073 81.839458-33.953451 11.045846-19.548523 7.500678-46.306666-9.98659-75.355093L646.322686 85.661369C627.876363 55.038372 604.47253 38.171389 580.419783 38.171389z"
                    fill="#6E6E96"
                    p-id="13937"
                  ></path>
                  <path
                    d="M596.279995 640.668596a33.399966 33.399966 0 0 1-33.399965-33.399966V353.447978a33.399966 33.399966 0 1 1 66.799931 0v253.815881a33.399966 33.399966 0 0 1-33.399966 33.404737zM596.279995 867.420962a33.399966 33.399966 0 0 1-33.399965-33.399966v-52.85306a33.399966 33.399966 0 1 1 66.799931 0v52.85306a33.399966 33.399966 0 0 1-33.399966 33.399966z"
                    fill="#6E6E96"
                    p-id="13938"
                  ></path>
                </svg>
              </div>
              <h3 class="confirm-description">{dialog.description}</h3>
            </el-row>
          </div>
        )
      }
      // --Input
      if (mode === 2) {
        return <div class="input-content">
          {this.dialog.description && <el-alert
            title="警告"
            description={this.dialog.description}
            type="warning"
            closable={false}
            show-icon
          >
          </el-alert>}
          <div class="input-box">
            {
              this.attrs.filter(a => !a.hidden && a.componentType && supperType.includes(a.componentType)).map(a => {
                return this.renderAttr(a)
              })
            }
          </div>
        </div>
      }

      return null
    },
    /** 渲染输入属性项 */
    renderAttr(attr) {
      const renderH = () => {
        const className = `item-name ${attr.required ? 'required' : ''}`
        return (
          <div class="input-item">
            {attr.name && <span class={className}>{attr.name}</span>}
            <div class="item-comp">
              {attr.componentType === ct.TEXT && this.renderText(attr)}
              {attr.componentType === ct.TEXTINPUT && this.renderTextInput(attr)}
              {attr.componentType === ct.UPLOADFILES && this.renderUploadFiles(attr)}
              {attr.componentType === ct.TEXTAREA && this.renderTextarea(attr)}
              {attr.componentType === ct.NUMBERINPUT && this.renderNumberInput(attr)}
              {attr.componentType === ct.SINGLESELECT && this.renderSingleSelect(attr, false)}
              {attr.componentType === ct.MULTIPLESELECT && this.renderSingleSelect(attr, true)}
              {attr.componentType === ct.DATEPICKER && this.renderDatePicker(attr, true)}
              {attr.componentType === ct.RADIOGROUP && this.renderRadioButtonGroup(attr, true)}
            </div>
          </div>)
      }
      if (attr.divider) {
        return <div>
          <div class="input-item">
            <el-divider content-position="left">{attr.divider}</el-divider>
          </div>
          {renderH()}
        </div>
      }

      return renderH()

    },
    /** 渲染文本展示组件 */
    renderText(attr) {
      return <div class="text-primary"><strong>{attr.value}</strong></div>
    },
    /** 渲染文件上传组件 */
    renderUploadFiles(attr) {
      const onFilesChange = (val) => {
        attr.value = val
      }
      return <CommUploadFiles
        postData={attr.postData}
        files={attr.value}
        max={attr.max}
        viewmode={attr.readOnly}
        acceptFileTypes={attr.acceptFileTypes}
        on-change={onFilesChange}
      />
    },
    /** 渲染文本输入组件 */
    renderTextInput(attr) {
      const onChange = val => {
        attr.value = val.trim()
        if (typeof attr.onChange === 'function') {
          attr.onChange(val, this)
        }
      }
      const onInput = val => {
        attr.value = val
      }
      return <el-input readOnly={attr.readOnly} size="small" value={attr.value} on-input={onInput} on-change={onChange} />
    },
    /** 渲染文本输入组件 */
    renderTextarea(attr) {
      const onChange = val => {
        attr.value = val.trim()
        if (typeof attr.onChange === 'function') {
          attr.onChange(val, this)
        }
      }
      const onInput = val => {
        attr.value = val
      }
      return <el-input type="textarea" rows={5} readOnly={attr.readOnly} size="small" value={attr.value} on-input={onInput} on-change={onChange} />
    },
    /** 渲染数字输入组件 */
    renderNumberInput(attr) {
      const onChange = val => {
        attr.value = val
        if (typeof attr.onChange === 'function') {
          attr.onChange(val, this)
        }
      }
      const onInput = val => {
        attr.value = val
      }
      return <el-input-number style="width:50%" min={attr.min} readOnly={attr.readOnly} size="small" value={attr.value} on-input={onInput} on-change={onChange} />
    },
    /** 渲染下拉选项组件 */
    renderSingleSelect(attr, multiple) {
      const onChange = val => {
        attr.value = val
        if (typeof attr.onChange === 'function') {
          attr.onChange(val, this)
        }
      }
      return (<el-select
        on-change={onChange}
        style="width:100%;"
        size="small"
        value={attr.value}
        placeholder="请选择"
        multiple={multiple}
        clearable
        disabled={attr.readOnly}
        filterable>
        {
          attr.dataSource.map(item => {
            return (<el-option
              key={item.ItemValue}
              label={item.ItemName}
              value={item.ItemValue}
            />
            )
          })
        }
      </el-select>)
    },
    /** 渲染日期组件 */
    renderDatePicker(attr) {
      const onChange = val => {
        attr.value = val
        if (typeof attr.onChange === 'function') {
          attr.onChange(val, this)
        }
      }
      return <el-date-picker
        size="small"
        style="width:100%;"
        value-format="yyyy-MM-dd"
        format="yyyy-MM-dd"
        value={attr.value}
        on-change={onChange}
        type="date"
        disabled={attr.readOnly}
        placeholder="选择日期" />

    },
    /** 单选组 */
    renderRadioButtonGroup(attr) {
      const onChange = val => {
        attr.value = val
        if (typeof attr.onChange === 'function') {
          attr.onChange(val, this)
        }
      }
      return (
        <div class="radio-group">
          {
            attr.dataSource.map(item => {
              let className = "radio-button small"
              if (item.ItemValue === attr.value) {
                className += " radio-current"
              }
              return (
                <div class={className} onClick={() => onChange(item.ItemValue)}>
                  {item.ItemName}</div>
              )
            })
          }
        </div>)
    },
    AppendComponent(comp) {
      this.compList.push(comp)
      console.log(comp, this.compList)
    },
    Options({ dialog = {
      title: 'CommDialog',
      width: '720px'
    }, okBtn = {
      text: '确定',
      show: true,
      icon: 'el-icon-check',
      type: 'primary'
    }, cancleBtn = {
      text: '取消',
      show: true,
      icon: 'el-icon-close',
      type: 'default'
    } }) {
      this.dialog.title = dialog.title || "CommDialog"
      this.dialog.width = dialog.width || "720px"
      this.btn.okBtn.text = okBtn.text || '确  定'
      this.btn.okBtn.show = typeof okBtn.show === 'undefined'? true : okBtn.show
      this.btn.okBtn.icon = okBtn.icon || 'el-icon-check'
      this.btn.okBtn.type = okBtn.type || 'primary'
      this.btn.cancleBtn.text = cancleBtn.text || '取  消'
      this.btn.cancleBtn.show = typeof cancleBtn.show === 'undefined'? true : cancleBtn.show
      this.btn.cancleBtn.icon = cancleBtn.icon || 'el-icon-close'
      this.btn.cancleBtn.type = cancleBtn.type || 'default'
    },
    Open(onOkCallback, onCancleCallback, onDialogClosed) {
      this.visible = true;
      this.mode = 0;
      this.onOkCallback = onOkCallback
      this.onCancleCallback = onCancleCallback
      this.onDialogClosed = onDialogClosed
    },
    /** 确认 */
    Confirm(title, description, onOkCallback, onCancleCallback, onDialogClosed) {
      this.dialog.title = title || "Confirm"
      this.dialog.description = description || "Description"
      this.dialog.width = "480px"
      this.btn.okBtn.show = true
      this.btn.cancleBtn.show = true
      this.mode = 1;
      this.onOkCallback = onOkCallback
      this.onCancleCallback = onCancleCallback
      this.onDialogClosed = onDialogClosed
      this.$nextTick(() => {
        this.visible = true;
      })
    },
    /** 简易输入:仅支持基本输入：Input,TextArea,Select,RadioGroup,DatePicker */
    SingleInput(title, description, width, attrs, onOkCallback, onCancleCallback, onDialogClosed) {
      this.dialog.title = title || "Input"
      this.dialog.description = description
      this.dialog.width = width || "480px"
      this.btn.okBtn.show = true
      this.btn.okBtn.text = "提  交"
      this.btn.cancleBtn.show = false
      this.mode = 2;
      this.attrs = (attrs || []).map(a => {
        a.componentType = a.componentType || ct.TEXTINPUT
        return a
      })
      this.onOkCallback = onOkCallback
      this.onCancleCallback = onCancleCallback
      this.onDialogClosed = onDialogClosed
      this.$nextTick(() => {
        this.visible = true;
      })
    },
    GetRefComponents() {
      return this.compList.filter(c => c.compRef).map(c => {
        return {
          refKey: c.compRef,
          refComp: this.$refs[c.compRef][0] || this.$refs[c.compRef]
        }
      })
    },
    onOK() {
      if (typeof this.onOkCallback === 'function') {
        if (this.mode === 0) {
          this.onOkCallback(this.GetRefComponents(), this.onClose)
        }
        if (this.mode === 1) {
          this.onOkCallback(this.onClose)
        }
        if (this.mode === 2) {
          this.onOkCallback([...this.attrs], this.onClose)
        }

      } else {
        this.onCancle()
      }
    },
    onClose() {
      if (typeof this.onDialogClosed === 'function') {
        this.onDialogClosed()
      }
      this.visible = false;

    },
    onCancle() {
      if (typeof this.onCancleCallback === 'function') {
        this.onCancleCallback(this.GetRefComponents(), this.onClose)
      } else {
        this.onClose()
      }

    }
  }

}
</script>

<style lang="scss">
.order-files-dialog {
  height: 100% !important;
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
  background: rgba(13, 10, 49, 0.75) !important;
  .el-dialog {
    max-height: 90% !important;
    max-width: 95% !important;
    min-width: 540px !important;
    display: flex;
    flex-direction: column;
    position: relative !important;
    margin: 0 auto !important;

    .el-dialog__body {
      padding: 15px;
      color: #606266;
      font-size: 14px;
      word-break: break-all;
      flex: 1;
      height: 99% !important;
      overflow-y: scroll;
      position: relative !important;
    }
  }
}

.confirm-icon {
  width: 120px;
  height: 60px;
  line-height: 60px;
  text-align: center;
}
.confirm-description {
  flex: 1;
  box-sizing: border-box;
  padding: 10px;
  color: #fb8c00;
  font-size: 18px;
  font-weight: bold;
}

.input-content {
  width: 100%;
  .notice-desc {
    color: #fb8c00;
    font-size: 14px;
    font-weight: 600;
    margin-top: 0 !important;
  }
  .input-box {
    border: 1px solid #f0f0f0;
    width: 100%;
    box-sizing: border-box;
    padding: 10px;
    margin-top: 10px;
    background-color: #fff;

    .input-item {
      display: inline-flex;
      display: -webkit-inline-flex;
      align-items: center;
      padding: 5px 10px;
      line-height: 18px;
      width: 100%;

      .el-divider--horizontal {
        display: block;
        height: 1px;
        width: 100%;
        margin: 10px 0;
        .el-divider__text {
          position: absolute;
          background-color: #ffffff;
          padding: 0 20px;
          font-weight: 600;
          color: #dc3545;
          font-size: 14px;
        }
      }
      .item-name {
        padding: 0 10px !important;
        color: #333;
        font-size: 12px;
        line-height: 12px;
        text-align: center;
        word-wrap: break-word;
        word-break: normal;
        width: 100px;
        box-sizing: border-box;

        &.required::before {
          content: "*";
          color: #dc3545;
          position: relative;
          font-size: 26px;
          margin: 0 3px;
          left: 0px;
          top: 6px;
        }
      }

      .item-comp {
        flex: 1;

        .radio-group {
          width: auto !important;

          .radio-button {
            box-sizing: border-box;
            padding: 0px 8px;
            line-height: 15px;
            height: 30px;
            font-size: 14px;
            margin: 2px 3px;
            border-radius: 15px;
            cursor: pointer;
            color: #ccc;
            font-size: 14px;
            transition: all 0.3s linear;
            min-width: 60px;
            display: inline-flex;
            display: -webkit-inline-flex;
            justify-content: center;
            align-items: center;
            border-bottom: 1px solid #f0f0f0;

            &::before {
              content: "✘";
            }

            &.small {
              padding: 0px 8px;
              line-height: 15px;
              height: 30px;
              font-size: 14px;
              border-radius: 15px;
            }
            &.mini {
              padding: 0px 5px;
              line-height: 14px;
              height: 24px;
              font-size: 12px;
            }

            &:hover {
              color: #000;
              border-bottom: 1px solid #000;
            }

            &.radio-current {
              color: #03a9f4;
              border-bottom: 1px solid #03a9f4;
              &::before {
                content: "✔";
              }
            }
          }
        }
      }
    }
  }
}
</style>